module.exports = __webpack_public_path__ + "media/assets/Users-06d741222cd892e5178d79a5722168d5.svg";